/**
 * avatars/presets/textures/arm-bare.js
 * Hàm tạo texture cho cánh tay trần / áo ba lỗ (arm_bare)
 */

export function generateArmBareTexture(ctx, size, options = {}) {
  // ----------------------------------------------------
  // CÁNH TAY TRẦN / ÁO BA LỖ (TEXTURE PHÂN BIỆT TAY VÀ BÀN TAY)
  // ----------------------------------------------------
  const skinColor = options.skinColor || '#fcd5b5';

  // 1. Nền màu da toàn bộ cánh tay
  ctx.fillStyle = skinColor;
  ctx.fillRect(0, 0, size, size);

  // 2. Ranh giới cổ tay (Wrist Crease Line) ở vị trí y = size * 0.72
  const wristY = size * 0.72;

  // Đường rãnh cổ tay màu da đậm hơn
  ctx.strokeStyle = 'rgba(180, 83, 9, 0.35)';
  ctx.lineWidth = size * 0.025;
  ctx.beginPath();
  ctx.moveTo(size * 0.1, wristY);
  ctx.lineTo(size * 0.9, wristY);
  ctx.stroke();

  // Vạch phụ nếp gấp cổ tay nhẹ phía trên
  ctx.strokeStyle = 'rgba(180, 83, 9, 0.20)';
  ctx.lineWidth = size * 0.015;
  ctx.beginPath();
  ctx.moveTo(size * 0.2, wristY - size * 0.035);
  ctx.lineTo(size * 0.8, wristY - size * 0.035);
  ctx.stroke();

  // Đổ bóng mu bàn tay nhẹ phía dưới cổ tay
  ctx.fillStyle = 'rgba(0, 0, 0, 0.06)';
  ctx.fillRect(size * 0.12, wristY + size * 0.02, size * 0.76, size * 0.22);

  // 3. Hoa văn sinh học chủng tộc trên phần da cánh tay để trần
  const speciesId = options.speciesId || '';
  if (speciesId === 'species_ignis') {
    ctx.strokeStyle = '#f97316';
    ctx.lineWidth = size * 0.02;
    ctx.beginPath();
    ctx.moveTo(size * 0.5, size * 0.1);
    ctx.lineTo(size * 0.45, size * 0.4);
    ctx.lineTo(size * 0.55, size * 0.65);
    ctx.stroke();
  } else if (speciesId === 'species_bionic') {
    ctx.strokeStyle = '#38bdf8';
    ctx.lineWidth = size * 0.015;
    ctx.beginPath();
    ctx.moveTo(size * 0.35, size * 0.15);
    ctx.lineTo(size * 0.35, size * 0.55);
    ctx.lineTo(size * 0.65, size * 0.55);
    ctx.stroke();
    ctx.fillStyle = '#00f0ff';
    ctx.beginPath();
    ctx.arc(size * 0.65, size * 0.55, 3, 0, Math.PI * 2);
    ctx.fill();
  } else if (speciesId === 'species_cryo') {
    ctx.strokeStyle = '#bae6fd';
    ctx.lineWidth = size * 0.015;
    ctx.beginPath();
    ctx.moveTo(size * 0.5, size * 0.25);
    ctx.lineTo(size * 0.5, size * 0.5);
    ctx.moveTo(size * 0.38, size * 0.38);
    ctx.lineTo(size * 0.62, size * 0.38);
    ctx.stroke();
  } else if (speciesId === 'species_ocean') {
    [
      [0.45, 0.25],
      [0.55, 0.42],
      [0.48, 0.58]
    ].forEach((pt) => {
      ctx.fillStyle = '#2dd4bf';
      ctx.beginPath();
      ctx.arc(size * pt[0], size * pt[1], 3, 0, Math.PI * 2);
      ctx.fill();
    });
  } else if (speciesId === 'species_drakonis') {
    ctx.strokeStyle = 'rgba(153, 27, 27, 0.6)';
    ctx.lineWidth = size * 0.015;
    ctx.strokeRect(size * 0.42, size * 0.25, size * 0.16, size * 0.16);
    ctx.strokeRect(size * 0.42, size * 0.45, size * 0.16, size * 0.16);
  } else if (speciesId === 'species_sylva') {
    ctx.strokeStyle = '#a3e635';
    ctx.lineWidth = size * 0.015;
    ctx.beginPath();
    ctx.moveTo(size * 0.5, size * 0.15);
    ctx.lineTo(size * 0.5, size * 0.65);
    ctx.moveTo(size * 0.5, size * 0.35);
    ctx.lineTo(size * 0.35, size * 0.25);
    ctx.stroke();
  } else if (speciesId === 'species_insect') {
    ctx.strokeStyle = 'rgba(245, 158, 11, 0.6)';
    ctx.lineWidth = size * 0.015;
    ctx.strokeRect(size * 0.4, size * 0.25, size * 0.2, size * 0.18);
    ctx.strokeRect(size * 0.4, size * 0.48, size * 0.2, size * 0.18);
  } else if (speciesId === 'species_venom') {
    [
      [0.45, 0.25],
      [0.55, 0.42],
      [0.48, 0.58]
    ].forEach((pt) => {
      ctx.fillStyle = '#34d399';
      ctx.beginPath();
      ctx.arc(size * pt[0], size * pt[1], 3, 0, Math.PI * 2);
      ctx.fill();
    });
  } else if (speciesId === 'species_dune') {
    ctx.strokeStyle = 'rgba(253, 224, 71, 0.5)';
    ctx.lineWidth = size * 0.015;
    [0.25, 0.42, 0.58].forEach((yPos) => {
      ctx.beginPath();
      ctx.moveTo(size * 0.25, size * yPos);
      ctx.lineTo(size * 0.75, size * yPos);
      ctx.stroke();
    });
  } else if (speciesId === 'species_seraph') {
    ctx.strokeStyle = 'rgba(250, 204, 21, 0.6)';
    ctx.lineWidth = size * 0.015;
    ctx.beginPath();
    ctx.moveTo(size * 0.5, size * 0.15);
    ctx.lineTo(size * 0.5, size * 0.65);
    ctx.stroke();
  } else if (speciesId === 'species_lithos') {
    ctx.strokeStyle = '#f59e0b';
    ctx.lineWidth = size * 0.015;
    ctx.beginPath();
    ctx.moveTo(size * 0.4, size * 0.25);
    ctx.lineTo(size * 0.6, size * 0.45);
    ctx.lineTo(size * 0.4, size * 0.65);
    ctx.stroke();
  } else if (speciesId === 'species_gem') {
    ctx.strokeStyle = 'rgba(251, 146, 60, 0.7)';
    ctx.lineWidth = size * 0.015;
    ctx.strokeRect(size * 0.42, size * 0.32, size * 0.16, size * 0.24);
  } else if (speciesId === 'species_mercury') {
    ctx.fillStyle = '#ffffff';
    [0.28, 0.5].forEach((yPos) => {
      ctx.beginPath();
      ctx.arc(size * 0.5, size * yPos, 3, 0, Math.PI * 2);
      ctx.fill();
    });
  } else if (speciesId === 'species_midas') {
    ctx.strokeStyle = '#fde047';
    ctx.lineWidth = size * 0.015;
    ctx.strokeRect(size * 0.4, size * 0.3, size * 0.2, size * 0.25);
  } else if (speciesId === 'species_steampunk') {
    ctx.strokeStyle = '#854d0e';
    ctx.lineWidth = size * 0.015;
    ctx.beginPath();
    ctx.arc(size * 0.5, size * 0.4, size * 0.1, 0, Math.PI);
    ctx.stroke();
  } else if (speciesId === 'species_fulgor') {
    ctx.strokeStyle = '#38bdf8';
    ctx.lineWidth = size * 0.015;
    ctx.beginPath();
    ctx.moveTo(size * 0.55, size * 0.2);
    ctx.lineTo(size * 0.45, size * 0.45);
    ctx.lineTo(size * 0.55, size * 0.7);
    ctx.stroke();
  } else if (speciesId === 'species_astral') {
    [
      [0.45, 0.25],
      [0.55, 0.45],
      [0.48, 0.65]
    ].forEach((pt) => {
      ctx.fillStyle = '#c7d2fe';
      ctx.beginPath();
      ctx.arc(size * pt[0], size * pt[1], 2.5, 0, Math.PI * 2);
      ctx.fill();
    });
  } else if (speciesId === 'species_zephyr') {
    ctx.strokeStyle = 'rgba(224, 242, 254, 0.6)';
    ctx.lineWidth = size * 0.015;
    ctx.beginPath();
    ctx.arc(size * 0.5, size * 0.4, size * 0.12, 0, Math.PI);
    ctx.stroke();
  } else if (speciesId === 'species_radiation') {
    [
      [0.45, 0.28],
      [0.55, 0.5]
    ].forEach((pt) => {
      ctx.fillStyle = '#bef264';
      ctx.beginPath();
      ctx.arc(size * pt[0], size * pt[1], 3, 0, Math.PI * 2);
      ctx.fill();
    });
  } else if (speciesId === 'species_graviton') {
    ctx.strokeStyle = '#a8a29e';
    ctx.lineWidth = size * 0.015;
    ctx.strokeRect(size * 0.38, size * 0.3, size * 0.24, size * 0.18);
  } else if (speciesId === 'species_chrono') {
    ctx.strokeStyle = '#fef08a';
    ctx.lineWidth = size * 0.012;
    [0.25, 0.4, 0.55].forEach((yPos) => {
      ctx.beginPath();
      ctx.moveTo(size * 0.35, size * yPos);
      ctx.lineTo(size * 0.65, size * yPos);
      ctx.stroke();
    });
  } else if (speciesId === 'species_nebula') {
    ctx.strokeStyle = 'rgba(232, 121, 249, 0.6)';
    ctx.lineWidth = size * 0.015;
    ctx.beginPath();
    ctx.arc(size * 0.5, size * 0.45, size * 0.14, 0, Math.PI);
    ctx.stroke();
    ctx.fillStyle = '#ffffff';
    ctx.beginPath();
    ctx.arc(size * 0.5, size * 0.35, 2, 0, Math.PI * 2);
    ctx.fill();
  } else if (speciesId === 'species_void') {
    ctx.strokeStyle = 'rgba(148, 163, 184, 0.5)';
    ctx.lineWidth = size * 0.015;
    ctx.strokeRect(size * 0.42, size * 0.32, size * 0.16, size * 0.2);
  } else if (speciesId === 'species_singularity') {
    ctx.strokeStyle = 'rgba(59, 130, 246, 0.7)';
    ctx.lineWidth = size * 0.016;
    ctx.beginPath();
    ctx.ellipse(size * 0.5, size * 0.45, size * 0.15, size * 0.07, 0, 0, Math.PI * 2);
    ctx.stroke();
  }
}
